import {ClipboardService} from "@services/clipboard/clipboard.service";
import {
    CHAT_ACTION_NAME,
    ChatActionBase,
    IChatActionList,
    IChatActionsData, IChatInputActionItem
} from "@core/base/chat-action-base";
import {logger} from "@services/logger/logger.service";

export class WebChatAction implements ChatActionBase {
    private errorForMethod = 'Method not implemented';

    public action: IChatActionList = {
        [CHAT_ACTION_NAME.selection]: {
            value: false,
            onBuildData: () => {}
        },
        [CHAT_ACTION_NAME.attachDocument]: {
            value: false,
            onBuildData: () => {}
        },
        [CHAT_ACTION_NAME.clipboard]: {
            value: false,
            onBuildData: this.buildDataForClipboard.bind(this)
        },
        [CHAT_ACTION_NAME.history]: {
            value: false,
            onBuildData: this.buildDataForHistory.bind(this)
        },
        [CHAT_ACTION_NAME.img]: {
            value: false,
            onBuildData: this.buildDataForImg.bind(this)
        }
    }

    constructor(private clipboard: ClipboardService) {
    }

    public isEditableHost(): boolean {
        return false;
    }

    public isReadableDocumentHost(): boolean {
        return false
    }

    public setTextToHost(text: string): void {
        throw new Error(this.errorForMethod);
    }

    public setImageToHost(image: string): void {
        throw new Error(this.errorForMethod);
    }

    public async getSelectedContentFromHost(): Promise<string> {
        throw new Error(this.errorForMethod);
    }

    public async getFullDocumentFromHost(): Promise<string> {
        throw new Error(this.errorForMethod);
    }

    public async getActionsData(): Promise<IChatActionsData> {
        return {
            attachDocument: '',
            img: false,
            history: [],
            selection: '',
            clipboard: ''
        }
    }

    public getActions(): IChatActionList {
        return this.action;
    }

    private async buildDataForClipboard(action: IChatInputActionItem): Promise<void> {
        const data = await this.clipboard.copyFrom();
        logger.log(data);
    }

    private buildDataForHistory(action: IChatInputActionItem): void {
        throw new Error("If you call a method on the web, you'll must implement it");
    }

    private buildDataForImg(action: IChatInputActionItem): void {
        throw new Error("If you call a method on the web, you'll must implement it");
    }

}
